import React from 'react';

const AXIS_TOP = 54;
const MARKER_TOP = 28;

export { AXIS_TOP, MARKER_TOP };

export const timelineStyles = {
    wrapper: {
        position: 'relative',
        marginTop: 8,
        borderRadius: 8,
        border: '1px solid #e1dfdd',
        background: '#f8f8f8',
        padding: '12px 16px',
    } as React.CSSProperties,
    legend: {
        display: 'flex',
        gap: 16,
        marginBottom: 8,
        flexWrap: 'wrap',
        paddingBottom: 8,
        borderBottom: '1px solid #e1dfdd',
    } as React.CSSProperties,
    track: {
        position: 'relative',
        height: 90,
        overflow: 'visible',
    } as React.CSSProperties,
    trackBackground: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: AXIS_TOP - 14,
        height: 28,
        background: '#edebe9',
        borderRadius: 4,
    } as React.CSSProperties,
    axis: {
        position: 'absolute',
        top: AXIS_TOP,
        left: 0,
        right: 0,
        height: 2,
        background: '#8a8886',
    } as React.CSSProperties,
    legendItem: {
        display: 'flex',
        alignItems: 'center',
        gap: 5,
        fontSize: 11,
        color: '#605e5c',
    } as React.CSSProperties,
};

export const infoLineStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    marginTop: 4,
    fontSize: 12,
    color: '#605e5c',
    minHeight: 20,
};

export const tickStyle = (left: number): React.CSSProperties => ({
    position: 'absolute',
    left: `${left}%`,
    top: AXIS_TOP - 6,
    width: 1,
    height: 8,
    background: '#c8c6c4',
    transform: 'translateX(-50%)',
});

export const tickLabelStyle = (left: number): React.CSSProperties => ({
    position: 'absolute',
    left: `${left}%`,
    top: AXIS_TOP + 8,
    fontSize: 11,
    color: '#605e5c',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap',
});

export const historyPointStyle = (left: number, isSelected: boolean, color: string, isSquare: boolean): React.CSSProperties => ({
    position: 'absolute',
    left: `${left}%`,
    top: AXIS_TOP - 5,
    width: isSelected ? 14 : 10,
    height: isSelected ? 14 : 10,
    borderRadius: isSquare ? 2 : '50%',
    background: color,
    transform: 'translateX(-50%)',
    cursor: 'pointer',
    zIndex: isSelected ? 4 : 2,
    outline: isSelected ? `2px solid ${color}` : 'none',
    outlineOffset: 2,
});

export const scanLineStyle = (left: number, tipTop: number, color: string): React.CSSProperties => ({
    position: 'absolute',
    left: `${left}%`,
    top: tipTop,
    width: 1,
    height: AXIS_TOP - tipTop + 2,
    background: color,
    transform: 'translateX(-50%)',
    zIndex: 1,
});

export const scanMarkerStyle = (left: number, isLoad: boolean, color: string): React.CSSProperties => ({
    position: 'absolute',
    left: `${left}%`,
    top: isLoad ? MARKER_TOP - 12 : MARKER_TOP,
    transform: 'translateX(-50%)',
    width: 0,
    height: 0,
    cursor: 'pointer',
    zIndex: 5,
    borderLeft: '7px solid transparent',
    borderRight: '7px solid transparent',
    ...(isLoad ? { borderBottom: `12px solid ${color}` } : { borderTop: `12px solid ${color}` }),
});
